import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Components
import {
    Grid,
    Select,
    FormControl,
    MenuItem,
    TextField,
    FormHelperText
} from '@material-ui/core';

import NumberFormat from 'react-number-format';

// css
import { withStyles } from '@material-ui/core';
const styles = theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    alignLeft: {
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center'
    },
    textField: {
        minWidth: '100%',
    },
    select: {
        minWidth: '100%',
    },
    gridHelperText: {
        padding: '0px !important',
    },
    helperText: {
        margin: '0 22px 0'
    },
    formField: {
        minWidth: '100%',
    },
});

function formatLength(value, maxLength) {
    let format = value.substring(0, maxLength);

    return format;
}

//Solo numeri sulla TextField
function NumberFormatCustom(props) {
    const { inputRef, onChange, maxLength, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        value: values.value,
                    },
                });
            }}
            allowNegative={false}
            allowLeadingZeros
            format={(value) => formatLength(value, maxLength)}
        />
    );
}


class FormFieldSN extends Component {
    constructor(props) {
        super(props);

        this.state = {
            select_sn: 'DueCifre',
        };

        this.onSelectChange = this.onSelectChange.bind(this);

    }

    componentDidUpdate(propsPrecedenti) {

        if (this.props.sn_due_cifre !== propsPrecedenti.sn_due_cifre || this.props.sn_quattro_cifre !== propsPrecedenti.sn_quattro_cifre) {
            this.props.onSNChange(this.props.sn_due_cifre.concat(this.props.sn_quattro_cifre));
        }

    }

    onSelectChange(newSelection) {
        if (newSelection !== this.state.select_sn) {

            this.setState({
                select_sn: newSelection,
            });

            if (newSelection === 'Manuale') {
                this.props.onSNChange(this.props.sn_due_cifre.concat(this.props.sn_quattro_cifre));
            }
            else if (newSelection === 'DueCifre') {

                // inizializzo sn_due_cifre all'anno corrente
                this.props.handleChangeFieldSN('sn_due_cifre', new Date().getFullYear().toString().substr(-2));

                // rigenero il codice sn_quattro_cifre
                this.props.genSN(this.props.sn_due_cifre);

                this.props.onSNChange(this.props.sn_due_cifre.concat(this.props.sn_quattro_cifre));
            }
        }

    }


    render() {
        const { classes, value, helperText, onSNChange, codiceUtente,
            handleChangeFieldSN, sn_due_cifre, sn_quattro_cifre } = this.props;
        const { select_sn } = this.state;

        if (codiceUtente == 'CODICEADMIN') {
            return (
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} className={classes.alignLeft}>
                        <FormControl
                            variant="outlined"
                            size="small"
                            fullWidth
                        >
                            <Select className={classes.select}
                                value={select_sn}
                                onChange={e => this.onSelectChange(e.target.value)}
                                autoWidth={false}
                            >
                                <MenuItem value={'DueCifre'}>Due cifre per l'anno</MenuItem>
                                <MenuItem value={'Manuale'}>Manuale</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        {select_sn === 'Manuale' ?
                            <TextField
                                value={value}
                                error={helperText !== '' ? true : false}
                                variant="outlined"
                                size="small"
                                label="Serial Number"
                                onChange={e => onSNChange(e.target.value)}
                                InputProps={{ inputComponent: NumberFormatCustom, inputProps: { maxLength: 6 } }}
                            />
                            :
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        value={sn_due_cifre}
                                        error={helperText !== '' ? true : false}
                                        label="Anno"
                                        onChange={e => handleChangeFieldSN('sn_due_cifre', e.target.value)}
                                        InputProps={{ inputComponent: NumberFormatCustom, inputProps: { maxLength: 2 } }}
                                        InputLabelProps={{ shrink: true, }}
                                        variant="outlined"
                                        size="small"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={8}>
                                    <TextField
                                        value={sn_quattro_cifre}
                                        error={helperText !== '' ? true : false}
                                        label="Serial Number"
                                        onChange={e => handleChangeFieldSN('sn_quattro_cifre', e.target.value)}
                                        InputProps={{ inputComponent: NumberFormatCustom, inputProps: { maxLength: 4 } }}
                                        variant="outlined"
                                        size="small"
                                    />
                                </Grid>
                            </Grid>
                        }
                    </Grid>
                    {helperText !== '' ?
                        <Grid item xs={12} sm={12} className={classes.gridHelperText}>
                            <FormHelperText
                                error={helperText !== '' ? true : false}
                                className={classes.helperText}
                            >
                                {helperText}
                            </FormHelperText>
                        </Grid>
                        : null
                    }
                </Grid>
            );
        }
        else {
            return (
                <TextField
                    className={classes.formField}
                    variant="outlined"
                    size="small"
                    label="Serial Number"
                    value={value}
                    InputProps={{ readOnly: true }}
                />
            );
        }

    }
}

FormFieldSN.propTypes = {
    onSNChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    helperText: PropTypes.string.isRequired,

    initializeField: PropTypes.func.isRequired,

    genSN: PropTypes.func.isRequired,
    handleChangeFieldSN: PropTypes.func.isRequired,
    sn_due_cifre: PropTypes.string.isRequired,
    sn_quattro_cifre: PropTypes.string.isRequired,

    codiceUtente: PropTypes.string.isRequired,
};

export default withStyles(styles)(FormFieldSN);